import React, { createContext, useContext, useMemo } from "react";
import { DEFAULT_FEATURE_FLAGS } from "../config/featureFlags";

// The context's default value is the flags themselves, so useFeatureFlags()
// resolves to the defaults even with no <FeatureFlagsProvider> mounted.
// This provider is not mounted anywhere in the app today (not added to
// index.js / App.js), so this file has no effect on current behavior.
const FeatureFlagsContext = createContext(DEFAULT_FEATURE_FLAGS);

/**
 * Optional provider for future use once per-brand overrides exist, e.g.:
 *   <FeatureFlagsProvider flags={brandFlags}><App /></FeatureFlagsProvider>
 * Not used anywhere currently.
 */
export function FeatureFlagsProvider({ flags, children }) {
  const value = useMemo(
    () => ({ ...DEFAULT_FEATURE_FLAGS, ...flags }),
    [flags]
  );
  return (
    <FeatureFlagsContext.Provider value={value}>
      {children}
    </FeatureFlagsContext.Provider>
  );
}

/**
 * Returns the current feature-flag values (all `true` by default).
 * Not called from any screen yet — added so future work can gate UI
 * without another infrastructure change.
 */
export function useFeatureFlags() {
  return useContext(FeatureFlagsContext);
}

export default FeatureFlagsContext;
